import type { FaireProductEntity } from "../../entity_types/product";

export const p_6ojodrlvur: FaireProductEntity = {
  token: "p_6ojodrlvur",
  type: "product",
  name: "Million Year Hug Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/389e4ad29154d2757cc6d5d7d8c8b07aa35cf593ee0c8d98fd404bea2efdca20/1549393943.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/bd23411a54417a948f212efa1dcdc35833519af5c403ba94aca93d177d04e861/1549394030.jpg",
    "https://cdn.faire.com/fastly/cfe8da7f6c99ec8fe920566042dd04ee2c766c481973b1d425da5a4a4b2e744b.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:09.032Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
